<nav class="navbar navbar-expand-lg fixed-top">
  <div class="container-fluid">
    <div class="navbar-brand">
      <img src="/assets/rettxlogo-white.png" class="logo me-2" [alt]="logoAlt" />
    </div>
  </div>
</nav>
<div class="error-screen">
  <main class="container">
    <ng-content></ng-content>
  </main>
</div>
